import FloatingBlock from "../components/FloatingBlock";
import ScreenshotMock from "../components/ScreenshotMock";
import WealthEmpireMock from "../components/WealthEmpireMock.js";
import FeatureCard from "../components/FeatureCard";

const HomePage = ({ navigate }) => {
  return (
    <main>
      {/* HERO SECTION */}
      <section style={{ minHeight: "100vh", display: "flex", alignItems: "center", position: "relative", overflow: "hidden", padding: "100px 5% 60px" }}>
        {/* BG blobs */}
        {[
          { color: "#A855F730", left: "-10%", top: "10%", size: 500 },
          { color: "#6C3CE125", right: "-5%", top: "30%", size: 400 },
          { color: "#3EAEFF20", left: "40%", bottom: "5%", size: 350 },
          { color: "#FFD70018", left: "20%", top: "50%", size: 300 },
        ].map((b, i) => (
          <div key={i} style={{
            position: "absolute", width: b.size, height: b.size, borderRadius: "50%",
            background: b.color, filter: "blur(80px)",
            left: b.left, right: b.right, top: b.top, bottom: b.bottom,
            animation: `blobFloat ${7 + i}s ease-in-out infinite`,
            animationDelay: `${i * 1.5}s`, pointerEvents: "none",
          }} />
        ))}

        <FloatingBlock color="#FF4757" style={{ left: "5%", top: "20%" }} delay={0} />
        <FloatingBlock color="#A855F7" style={{ left: "8%", top: "70%" }} delay={1} />
        <FloatingBlock color="#FFD700" style={{ right: "8%", top: "15%" }} delay={2} />
        <FloatingBlock color="#3EAEFF" style={{ right: "12%", bottom: "25%" }} delay={0.5} />
        <FloatingBlock color="#2ED573" style={{ left: "18%", bottom: "15%" }} delay={1.5} />

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", maxWidth: 1200, margin: "0 auto", gap: 60, flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 300, animation: "fadeUp 0.8s ease both" }}>
            <div style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "rgba(168,85,247,0.12)", border: "1px solid rgba(168,85,247,0.3)",
              borderRadius: 50, padding: "6px 18px", marginBottom: 24, fontSize: 13, fontWeight: 700, color: "#A855F7"
            }}>
              🕹️ Independent Game Studio
            </div>
            <h1 style={{
              fontFamily: "'Fredoka One', cursive",
              fontSize: "clamp(48px, 7vw, 80px)",
              lineHeight: 1.05,
              marginBottom: 24,
            }}>
              <span style={{ background: "linear-gradient(135deg, #fff 30%, rgba(255,255,255,0.7))", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>Games That</span>
              <br />
              <span style={{
                background: "linear-gradient(135deg, #A855F7, #6C3CE1, #3EAEFF)",
                backgroundSize: "200% 200%",
                animation: "gradientFlow 3s ease infinite",
                WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent"
              }}>Keep You Hooked!</span>
            </h1>
            <p style={{ fontSize: 18, color: "rgba(255,255,255,0.65)", lineHeight: 1.7, marginBottom: 36, maxWidth: 480 }}>
              NovuliGames crafts addictive mobile experiences - from brain-teasing puzzles to empire-building tycoons. Always free. Always fun.
            </p>
            <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
              <button className="btn-primary" style={{ fontSize: 16 }}
                onClick={() => navigate("/games")}>
                🎮 Explore All Games
              </button>
              <button className="btn-secondary"
                onClick={() => window.open("https://play.google.com/store", "_blank")}>
                ▶ Play Store ↗
              </button>
            </div>
            {/* <div style={{ display: "flex", gap: 32, marginTop: 48, flexWrap: "wrap" }}>
              {[["🎮","2+","Games"],["📥","10K+","Downloads"],["⭐","4.8+","Avg Rating"]].map(([icon,val,label]) => (
                <div key={label}>
                  <div style={{ fontSize: 13, color: "rgba(255,255,255,0.4)", marginBottom: 2 }}>{icon} {label}</div>
                  <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: 28, color: "#A855F7" }}>{val}</div>
                </div>
              ))}
            </div> */}
          </div>

          {/* Dual Game Preview */}
          <div style={{ display: "flex", gap: 20, justifyContent: "center", flex: "0 0 auto", animation: "fadeUp 0.8s ease 0.2s both", flexWrap: "wrap" }}>
            <div style={{ position: "relative", transform: "rotate(-3deg)", cursor: "pointer", transition: "transform 0.3s" }}
              onMouseEnter={e => e.currentTarget.style.transform = "rotate(0deg) scale(1.03)"}
              onMouseLeave={e => e.currentTarget.style.transform = "rotate(-3deg)"}
              onClick={() => navigate("/games/color-clash")}
            >
              <div style={{ position: "absolute", inset: -30, background: "radial-gradient(ellipse, #FF475722, transparent 70%)", borderRadius: "50%", animation: "blobFloat 5s ease-in-out infinite" }} />
              <ScreenshotMock />
              <div style={{ textAlign: "center", marginTop: 12, fontFamily: "'Fredoka One', cursive", color: "#FF4757", fontSize: 14 }}>Color Clash</div>
            </div>
            <div style={{ position: "relative", transform: "rotate(3deg)", cursor: "pointer", transition: "transform 0.3s" }}
              onMouseEnter={e => e.currentTarget.style.transform = "rotate(0deg) scale(1.03)"}
              onMouseLeave={e => e.currentTarget.style.transform = "rotate(3deg)"}
              onClick={() => navigate("/games/wealth-empire")}
            >
              <div style={{ position: "absolute", inset: -30, background: "radial-gradient(ellipse, #FFD70022, transparent 70%)", borderRadius: "50%", animation: "blobFloat 6s ease-in-out infinite 1s" }} />
              <WealthEmpireMock />
              <div style={{ textAlign: "center", marginTop: 12, fontFamily: "'Fredoka One', cursive", color: "#FFD700", fontSize: 14 }}>Wealth Empire</div>
            </div>
          </div>
        </div>
      </section>

      {/* OUR GAMES SECTION */}
      <section id="features" style={{ padding: "80px 5%", background: "rgba(255,255,255,0.015)" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 60 }}>
            <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: "clamp(32px, 5vw, 52px)", marginBottom: 16 }}>
              Our <span style={{ color: "#A855F7" }}>Games</span>
            </div>
            <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 16 }}>Two worlds, endless fun - more coming soon</p>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 28 }}>
            {/* Color Clash Card */}
            <div style={{
              background: "rgba(255,71,87,0.05)",
              border: "1px solid rgba(255,71,87,0.2)",
              borderRadius: 28, padding: "36px 32px",
              transition: "transform 0.3s, box-shadow 0.3s",
              cursor: "pointer", position: "relative", overflow: "hidden",
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-8px)"; e.currentTarget.style.boxShadow = "0 24px 60px #FF475733"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
              onClick={() => navigate("/games/color-clash")}
            >
              <div style={{ position: "absolute", top: -40, right: -40, fontSize: 140, opacity: 0.04, fontFamily: "'Fredoka One', cursive" }}>🎨</div>
              <div style={{ fontSize: 56, marginBottom: 16 }}>🎨</div>
              <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: 28, color: "#FF4757", marginBottom: 10 }}>Color Clash</div>
              <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 15, lineHeight: 1.7, marginBottom: 24 }}>
                A brain-teasing flood puzzle. Flood the entire board with one color in limited moves. Simple to learn, impossible to put down!
              </p>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 24 }}>
                {["Puzzle","Strategy","Offline"].map(tag => (
                  <span key={tag} style={{ fontSize: 11, fontWeight: 700, padding: "4px 12px", borderRadius: 20, background: "rgba(255,71,87,0.15)", color: "#FF4757", border: "1px solid rgba(255,71,87,0.3)" }}>{tag}</span>
                ))}
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <button className="btn-primary" style={{ fontSize: 13, padding: "10px 20px" }} onClick={(e) => { e.stopPropagation(); navigate("/games/color-clash"); }}>View Game →</button>
                <button className="btn-secondary" style={{ fontSize: 13, padding: "10px 20px" }} onClick={(e) => { e.stopPropagation(); window.open("https://play.google.com/store", "_blank"); }}>Play Store</button>
              </div>
            </div>

            {/* Wealth Empire Card */}
            <div style={{
              background: "rgba(255,215,0,0.05)",
              border: "1px solid rgba(255,215,0,0.2)",
              borderRadius: 28, padding: "36px 32px",
              transition: "transform 0.3s, box-shadow 0.3s",
              cursor: "pointer", position: "relative", overflow: "hidden",
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-8px)"; e.currentTarget.style.boxShadow = "0 24px 60px #FFD70033"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
              onClick={() => navigate("/games/wealth-empire")}
            >
              <div style={{ position: "absolute", top: -40, right: -40, fontSize: 140, opacity: 0.04, fontFamily: "'Fredoka One', cursive" }}>💰</div>
              <div style={{ fontSize: 56, marginBottom: 16 }}>💰</div>
              <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: 28, color: "#FFD700", marginBottom: 10 }}>Wealth Empire</div>
              <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 15, lineHeight: 1.7, marginBottom: 24 }}>
                An idle tycoon empire builder. Start from a lemonade stand, expand to skyscrapers. Manage businesses and grow your empire to billions!
              </p>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 24 }}>
                {["Idle","Tycoon","Clicker"].map(tag => (
                  <span key={tag} style={{ fontSize: 11, fontWeight: 700, padding: "4px 12px", borderRadius: 20, background: "rgba(255,215,0,0.15)", color: "#FFD700", border: "1px solid rgba(255,215,0,0.3)" }}>{tag}</span>
                ))}
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <button className="btn-gold" style={{ fontSize: 13, padding: "10px 20px" }} onClick={(e) => { e.stopPropagation(); navigate("/games/wealth-empire"); }}>View Game →</button>
                <button className="btn-secondary" style={{ fontSize: 13, padding: "10px 20px" }} onClick={(e) => { e.stopPropagation(); window.open("https://play.google.com/store", "_blank"); }}>Play Store</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHY NOVULIGAMES */}
      <section style={{ padding: "80px 5%" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 60 }}>
            <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: "clamp(32px, 5vw, 52px)", marginBottom: 16 }}>
              Why <span style={{ color: "#3EAEFF" }}>NovuliGames?</span>
            </div>
            <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 16 }}>We build games that respect your time and wallet</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 20 }}>
            {[
              { icon: "🎮", title: "Made with Passion", desc: "Every game is crafted with care, designed to be genuinely fun and satisfying from the first tap.", color: "#A855F7" },
              { icon: "📵", title: "Offline First", desc: "All our games work without internet. Play on the plane, subway, or anywhere life takes you.", color: "#3EAEFF" },
              { icon: "🚫", title: "No Pay-to-Win", desc: "Fair and balanced games. Skill and strategy win - not your wallet.", color: "#2ED573" },
              { icon: "🔒", title: "Privacy Focused", desc: "We don't collect personal data. Your gameplay stays private and secure on your device.", color: "#FFD700" },
              { icon: "⚡", title: "Optimized Performance", desc: "Smooth 60fps gameplay on a wide range of Android devices, no lag, no stutter.", color: "#FF4757" },
              { icon: "🔄", title: "Frequent Updates", desc: "New levels, features, and entire games added regularly. There's always something fresh to play.", color: "#FF6B81" },
            ].map(f => <FeatureCard key={f.title} {...f} />)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: "80px 5%", textAlign: "center", position: "relative", overflow: "hidden" }}>
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(135deg, #A855F712, #6C3CE112, #3EAEFF12, #FFD70012)",
          backgroundSize: "400% 400%", animation: "gradientFlow 8s ease infinite"
        }} />
        <div style={{ position: "relative", maxWidth: 640, margin: "0 auto" }}>
          <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: "clamp(32px,5vw,56px)", marginBottom: 20, lineHeight: 1.1 }}>
            Ready to <span style={{ color: "#A855F7" }}>Play?</span>
          </div>
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 17, marginBottom: 40, lineHeight: 1.7 }}>
            Download our games for free on Google Play and join thousands of players already hooked!
          </p>
          <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
            <button className="btn-primary" style={{ fontSize: 16, padding: "16px 36px", display: "flex", alignItems: "center", gap: 10 }}
              onClick={() => navigate("/games")}>
              🎮 Browse All Games
            </button>
            <button className="btn-secondary" style={{ fontSize: 15, padding: "15px 30px" }}
              onClick={() => window.open("https://play.google.com/store", "_blank")}>
              ▶ Google Play Store
            </button>
          </div>
          <div style={{ marginTop: 30, color: "rgba(255,255,255,0.3)", fontSize: 13 }}>Free to download · Privacy first · Works offline</div>
        </div>
      </section>
    </main>
  );
};

export default HomePage;